function hideWidgetIfZeroRating() {
  const widgetTag = "etrusted-product-review-list-widget-product-star-extension";
  var _body = document.body;

  // Wait until the widget appears in the DOM
  const observer = new MutationObserver(() => {
    const widget = document.querySelector(widgetTag);
    if (widget) {
      const starExtension = widget.querySelector("etrusted-star-extension");

      // Wait until shadowRoot is attached
      if (starExtension && starExtension.shadowRoot) {
        const ratingElement = starExtension.shadowRoot.querySelector("etrusted-rl-star-rating");

        if (ratingElement) {
          const ratingValue = parseFloat(ratingElement.getAttribute("rating"));

          if (ratingValue === 0) {
            widget.style.display = "none";
            _body.classList.add("hide-etrusted-widget-zero-rating");
          } else {
            _body.classList.add("show-review-section");
          }

          // Once done, stop observing
          observer.disconnect();
        }
      }
    }
  });

  // Observe body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", function () {
  hideWidgetIfZeroRating();
});
